<template>
    <div class="avance">
        <div class="container mt-4 pb-5">
            <div v-if="surveys !== null && surveys.data && surveys.data.length" class="row">
                <div v-for="survey in surveys.data" class="col-12 col-md-6 col-lg-4 my-md-2 my-2 ">
                    <div class="mx-auto border-1 bg-white text-bat p-3 rounded shadow rounded-4 h-100">
                        <div class="row">
                            <div class="col-7">
                                <h6>{{ survey.name }}</h6>
                            </div>
                            <div class="col-5 d-flex align-items-top justify-content-end">
                                <div v-if="survey.client_survey.length === 0">
                                    <span class="border border-info border-1 rounded-4 px-2 py-1 text-info fs-7 fs-sm-7 fw-bolder">
                                        Sin iniciar
                                    </span>
                                </div>
                                <div v-else-if=" survey.client_survey[0].status === 'pending'">
                                    <span class="border-orange border-1 rounded-4 px-2 py-1 text-orange fs-7 fs-sm-7 fw-bolder">
                                        En progreso
                                    </span>
                                </div>
                                <div v-else-if=" survey.client_survey[0].status === 'finish'" class="estado">
                                    <span class="border border-danger border-1 rounded-4 px-2 py-1 text-danger fs-7 fs-sm-7 fw-bolder">
                                        Finalizado
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-10 d-flex flex-column">
                            <div v-if="survey.points_to_win > 0">
                                <span class="fs-7"> <strong> {{ survey.points_to_win }} Puntos</strong></span>
                            </div>
                            <span class="fs-7 truck-title">{{ survey.description }}</span>
                        </div>
                        <div v-if="survey.client_survey.length === 0 || survey.client_survey[0] === []" class="mb-3">
                            <a :href="`/survey/${survey.id}`" class="text-orange float-end">
                            <strong>Comenzar</strong>
                            </a>
                        </div>
                        <div v-else-if="survey.client_survey[0].status === 'pending'" class="mb-3">
                            <a :href="`/survey/${survey.id}`" class="text-orange float-end">
                            <strong>Continuar</strong>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center" v-if="surveys.last_page > 1">
                    <div class="col-md-6 d-flex justify-content-center">
                        <ul class="pagination my-2">
                            <li class="page-item" :class="surveys.prev_page_url === null ? 'disable' : ''">
                                <a v-if="surveys.current_page-1 > 1" class="page-link cursor-pointer" @click="getSurveys(surveys.current_page - 1)">Anterior</a>
                                <span v-else class="cursor-block"><</span>
                            </li>
                            <li class="page-item">
                                <a v-if="surveys.current_page-2 > 1" @click="getSurveys(1)" class="p-2 page-link cursor-pointer">{{ 1 }}</a>
                            </li>
                            <li v-if="surveys.current_page-2 >= 1" class="page-item">
                                <span class="page-link">...</span>
                            </li>
                            <li v-if="surveys.current_page > 1" class="page-item">
                                <a @click="getSurveys(surveys.current_page - 1)" class="p-2 page-link cursor-pointer">{{ surveys.current_page - 1 }}</a>
                            </li>
                            <li class="page-item active">
                                <a class="p-2 page-link cursor-default">{{ surveys.current_page }}</a>
                            </li>
                            <li v-if="surveys.current_page < surveys.last_page" class="page-item">
                                <a @click="getSurveys(surveys.current_page + 1)" class="p-2 page-link cursor-pointer">{{ surveys.current_page + 1 }}</a>
                            </li>
                            <li v-if="surveys.current_page+2 <= surveys.last_page" class="page-item">
                                <a class="p-2 page-link">...</a>
                            </li>
                            <li v-if="surveys.current_page+2 < surveys.last_page" class="page-item">
                                <a @click="getSurveys(surveys.last_page)" class="p-2 page-link cursor-pointer">{{ surveys.last_page }}</a>
                            </li>
                            <li class="page-item" :class="surveys.current_page >= surveys.last_page ? 'disable' : ''">
                                <span v-if="surveys.current_page !== surveys.last_page" @click="getSurveys(surveys.current_page + 1)" class="cursor-pointer">></span>
                                <span v-else class="cursor-block">></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-else-if="surveys === null && loading" class="mt-5">
                <initial-loading></initial-loading>
            </div>
            <div v-else class="text-center py-10">
                <h5>Actualmente no hay contenido disponibles</h5>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        url_storage: {
            default: null,
        },
    },
    data() {
        return {
            loading: 0,
            surveys: null,
            currentPage: 1,
        }
    },
    created () {
        const urlParams = new URLSearchParams(window.location.search);
        this.currentPage = (urlParams.get('option') === 'survey')?parseInt(urlParams.get('page')) || 1:1;
        this.getSurveys(this.currentPage );
    },
    methods: {
        updateURL() {
            const queryParams = new URLSearchParams();
            let url = '';
            queryParams.set('option', 'survey');
            if (this.currentPage !== 1 ) {
                queryParams.set('page', this.currentPage);
            }
            url += `?${queryParams.toString()}`;
            window.history.pushState({}, '', url);
        },
        getSurveys(page){
            const urlParams = new URLSearchParams(window.location.search);
            this.loading++
            axios.get(`/get-surveys?page=${page}`)
                 .then(({data}) => {
                     this.surveys = data.surveys
                     this.loading--;
                     this.currentPage = page;
                     if(urlParams.get('option') === 'survey'){
                         this.updateURL();
                     }
                 })
        },
    },
}

</script>
